import React, { useMemo, useState } from "react"
import { graphql } from "gatsby"
import Layout from "@components/layout"
import SEO from "@components/seo"
import { Container, Row, Col } from "react-bootstrap"
import { LazyLoadComponent } from "react-lazy-load-image-component"
import { StaticImage, getImage } from "gatsby-plugin-image"
import ShopSwiper from "@components/swiper/swiper-main-category"
import Category from "@components/sections/shop-subcategory"
import Story from "@components/sections/shop-story"
import Sale from "@components/sections/sale-shop-category"
import Partner from "@components/sections/certificate"
import Foundation from "@components/sections/foundation-echo"

const ProductMainCategoryTemplate = props => {
  const { data } = props
  const {
    bigCommerceCategories,
    allBigCommerceCategories,
    allBigCommerceProducts,
    allSanityProduct,
    sanityCategory,
    allSanityCard,
    allProds,
    allSanityProductCategory,
    allCardProducts,
  } = data
  console.log("allSanityCard", allSanityCard)
  console.log("allSanityProduct", allSanityProduct)
  const allProducts = [...allSanityCard.group, ...allSanityProduct.group]
  const [currentCategory, setCurrentCategory] = useState(
    sanityCategory._id || "4753729d-0cb9-4e28-9678-8e3926bdf93b"
  )

  const currentdata = useMemo(() => {
    let _data = allProducts

    if (currentCategory !== "") {
      _data = _data.filter(el => el.fieldValue === currentCategory)
    }

    return _data
  }, [allSanityCard, currentCategory])

  const saleProducts = currentdata[0]?.nodes?.filter(
    item => item.dealsPackages === true
  )

  console.log("currentdata", currentdata)
  console.log("currentCategory", currentCategory)
  console.log("allProducts", allProducts)
  console.log("sanityCategory", sanityCategory)

  const image = getImage(sanityCategory.heroBg.asset)
  // const image = getImage(placeholderImage)

  // Use like this:
  // const bgImage = convertToBgImage(image)

  // console.log("image", image)


  return (
    <Layout>
      <SEO title={sanityCategory?.title || ""} />
      <div id="product-category">
        <section className="shop-hero">
          <Container fluid className="px-0">
            <Row>
              <Col>
                {sanityCategory?.heroBg?.asset && (
                  <LazyLoadComponent>
                    <div
                      className="page-hero text-center"
                      style={{
                        backgroundImage: `url(${image?.images.fallback.src || ""})`,
                      }}
                    >
                      {sanityCategory?.title && (
                        <h1 className="section-title mb-5">
                          {sanityCategory?.title}
                        </h1>
                      )}
                      {sanityCategory?.subtitle && (
                        <h4 className="mb-0">{sanityCategory?.subtitle}</h4>
                      )}
                      {/* <img className="img-fluid" src={sanityCategory?.heroBg?.asset?.url} alt={sanityCategory.title}/> */}

                      {/* <GatsbyImage
                        imgClassName="img-fluid"
                        image={heroImage}
                        alt={sanityCategory?.title}
                      /> */}
                    </div>
                  </LazyLoadComponent>
                )}
              </Col>
            </Row>
          </Container>
          <div className="echo-greeting-wrapper">
            <StaticImage
              className="img-fluid"
              src="../images/echo-greeting.png"
              alt="Echo greeting"
            />
          </div>
        </section>
        {sanityCategory?.productSubcategory.length > 1 && (
          <section className="category-swiper py-0">
            <Container fluid>
              <LazyLoadComponent>
                <ShopSwiper
                  categories={sanityCategory?.productSubcategory}
                  setCurrentCategory={setCurrentCategory}
                  currentCategory={currentCategory}
                />
              </LazyLoadComponent>
            </Container>
          </section>
        )}
        <Category
          products={currentdata[0]?.nodes}
          sanity_card_products={allCardProducts?.nodes}
          sanity_products={allProds?.nodes}
          productCategory={sanityCategory}
          bcProducts={allBigCommerceProducts?.nodes}
          currentCategory={currentCategory}
        />
        {sanityCategory.storyHeading && sanityCategory.storySubHeading && (
          <Story productCategory={sanityCategory} />
        )}
        {saleProducts !== undefined && saleProducts.length > 0 ? (
          <Sale
            products={allBigCommerceProducts.nodes}
            sanity_products={saleProducts}
            // sanity_products={allSanityProduct.nodes}
            productCategory={sanityCategory}
          />
        ) : (
          ""
        )}
        {sanityCategory?.certificates.length > 0 && (
          <Partner
            images={sanityCategory?.certificates}
            bgColor="transparent"
            title={sanityCategory?.certificateTitle}
          />
        )}
        <Foundation />
      </div>
    </Layout>
  )
}

export default ProductMainCategoryTemplate

export const query = graphql`
  query($id: String!) {
    sanityCategory(id: { eq: $id }) {
      _id
      heroBg {
        asset {
          url
          gatsbyImageData(
            fit: FILL
            layout: FULL_WIDTH
            outputPixelDensities: 1.5
            placeholder: BLURRED
            width: 1366
          )
        }
      }
      title
      description
      productHeading {
        heading
        subHeading
      }
      productSubcategory {
        id
        _id
        title
        description
        subtitle
        slug {
          current
        }
        sortOrder
      }
      themeColor
      productPromoHeading
      storyCalltoAction
      storyHeading
      storySubHeading
      storyBackgroundImage {
        asset {
          url
        }
      }
      certificateTitle
      certificates {
        title
        icon {
          asset {
            gatsbyImageData(placeholder: BLURRED, formats: JPG)
          }
        }
      }
    }
    allSanityCard(sort: { fields: newProduct, order: DESC }) {
      group(field: productSubcategory____id) {
        fieldValue
        nodes {
          productName
          productId
          title
          newProduct
          dealsPackages
          slug {
            current
          }
          imageGallery {
            asset {
              url
              gatsbyImageData(
                placeholder: BLURRED
              )
            }
          }
          productSubcategory {
            _id
            title
            slug {
              current
            }
          }
          certificates {
            title
            icon {
              asset {
                url
              }
            }
          }
        }
      }
    }
    allSanityProduct {
      group(field: productSubcategory____id) {
        fieldValue
        nodes {
          id
          title
          slug {
            current
          }
          imageGallery {
            asset {
              url
              gatsbyImageData(
                placeholder: BLURRED
              )
            }
          }
          productSubcategory {
            id
            title
            slug {
              current
            }
          }
        }
      }
    }
    allCardProducts: allSanityCard(filter: { newProduct: { eq: true } }) {
      nodes {
        id
        title
        productName
        productId
        newProduct
        dealsPackages
        slug {
          current
        }
        imageGallery {
          asset {
            url
            gatsbyImageData(
              placeholder: BLURRED
            )
          }
        }
        productSubcategory {
          id
          title
          slug {
            current
          }
        }
      }
    }
    allProds: allSanityProduct {
      nodes {
        id
        title
        productName
        productId
        slug {
          current
        }
        productSubcategory {
          id
          title
          slug {
            current
          }
        }
        imageGallery {
          asset {
            url
            gatsbyImageData(
              placeholder: BLURRED
            )
          }
        }
      }
    }
    allSanityProductCategory(
      sort: { fields: sortOrder, order: ASC }
      filter: { title: { ne: "Drinkware" } }
    ) {
      nodes {
        id
        title
        description
        themeColor
        slug {
          current
        }
        _id
      }
    }

    allBigCommerceProducts {
      nodes {
        id
        bigcommerce_id
        name
        calculated_price
      }
    }
  }
`
